import * as yup from "yup";

import { SSN_REGEX } from "@constants";
import { Translations, i18n } from "@i18n";
import { VerifiedFormValues } from "./types";

export const validationSchema: yup.SchemaOf<VerifiedFormValues> = yup.object().shape({
  firstName: yup.string().required(i18n.t(Translations.NameRouteFirstNameInputRequired)),
  lastName: yup.string().required(i18n.t(Translations.NameRouteLastNameInputRequired)),
  address: yup.string().required(i18n.t(Translations.AddressFormAddressRequired)),
  address2: yup.string(),
  city: yup.string().required(i18n.t(Translations.AddressFormCityRequired)),
  state: yup.string().required(i18n.t(Translations.AddressFormStateRequired)),
  zipCode: yup.string().required(i18n.t(Translations.AddressFormZipCodeRequired)),
  ssn: yup
    .string()
    .test("is-valid-ssn", i18n.t(Translations.SsnRouteInputInvalid), function (value) {
      if (value && value.length > 0) {
        return SSN_REGEX.test(value);
      }
      return true;
    })
    .notRequired(),
});
